// extracted by mini-css-extract-plugin
export default {"root":"forms_root__0Z26C","error":"forms_error__+Av-8"};